import { css } from '@lastbrand/web-ui-styled-system/css'

// paddingTop was dropped: the header→row offset it produced is now owned by ProductPropertyDS's
// content wrapper (`marginTop: space-12` in product-property-ds.styles.ts).
export const optionRowDsClass = css({
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'center',
  gap: 'space-8',
})
